import Shipping from '../../src/legacy/Shipping.tsx';
export default Shipping;
